import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvService } from './env.service';
import { LoaderService } from './loader.service'; 

@Injectable({
  providedIn: 'root'
})

export class GeneralMasterService {
  constructor(
    private http: HttpClient,
    private env: EnvService,
    private loader: LoaderService
  ) { }
  /**
   * @package GeneralMasterService
   * @instance requestApiForGeneralMaster
   * @author Vikash Chaudhary
   * @description call different endpoint for retrieving list or manipulating single record of general master
   * @param requiredPayload * required payload body
   * @param endPoint * required end point
   * @return Observable 
   * 
   */
  requestApiForGeneralMaster(requiredPayload: any, endPoint: string): Observable<any> {
    return this.http.post<any>(this.env.apiUrl + endPoint, requiredPayload)
  }

   /**
   * @package GeneralMasterService
   * @instance requestApiForNotificationManagement
   * @author Vikash Chaudhary
   * @description call different endpoint for retrieving record or activity related to notification configuration
   * @param requiredPayload * required payload body
   * @param endPoint * required end point
   * @return Observable 
   * 
   */
  requestApiForNotificationManagement(requiredPayload: any, endPoint: string): Observable<any> {
    return this.http.post<any>(this.env.notificationApiURL + endPoint, requiredPayload)
  }

  /**
   * @package GeneralMasterService
   * @instance requestActionRestAPI
   * @author Vikash Chaudhary
   * @description call different endpoint  manipulating single record of general master
   * @param mainObject * required retrieve values from main object
   * @param requiredPayload * required request payload
   * @param endPoint * required end point append to main base url
   * @param actionType * required like Adding , Updating etc..
   * @return Promise 
   * 
   */
  requestActionRestAPI(mainObject: any, requiredPayload: any, endPoint: string, actionType: string) {
    return new Promise((resolve, reject) => {
      this.loader.showSpinner(actionType + mainObject.entityBusinessName);
      this.requestApiForGeneralMaster(requiredPayload, endPoint).subscribe((record: any) => {
        this.loader.hideSpinner();
        if (record.statusCode === "200") {
          resolve(record.responseList[0]);
        } else {
          reject(record.errorMessage)
        }
      }, (error: HttpErrorResponse) => {
        this.loader.hideSpinner();
        reject('Either Internet is not working or some internal server issue');
      })
    })
  }

}
